<template>
    <div class="o-photos">
        <m-title title="Dodaj zdjęcie" />
        <a-button
            type="fullwidth"
            @click="loadFromGallery"
        >
            Załaduj z Galerii
        </a-button>
        <div v-show="img == null">
            <p class="a-label">Podgląd</p>
            <vue-web-cam
                ref="webcam"
                :device-id="deviceId"
                width="100%"
                @error="onError"
                @cameras="onCameras"
                @camera-change="onCameraChange"
            />
            <br /><br />
            <p class="a-label">Kamera</p>
            <select
                v-model="camera"
                class="a-selectInput"
            >
                <option>-- Wybierz kamerę --</option>
                <option
                    v-for="device in devices"
                    :key="device.deviceId"
                    :value="device.deviceId"
                >{{ device.label }}</option>
            </select>
            <!-- <a-select
                name="device"
                placeholder="Wybierz urządzenie..."
            /> -->
            <br /><br />
            <a-button
                type="fullwidth"
                @click="onCapture"
            >
                Zrób zdjęcie
            </a-button>
        </div>
        <div v-show="img === null || (img !== null && libraryPhoto === true)">
            <vue-picture-input
                :custom-strings="{
                    tap:'Załaduj z galerii',
                    change:'Zmień zdjęcie',
                    remove:'Zrób zdjęcie',
                    upload:'Załaduj z galerii',
                    drag:'Załaduj z galerii',
                    fileSize: 'Wskazany plik jest za duży',
                }"
                :crop="false"
                class="o-photos__pictureInput"
                :class="{'o-photos__pictureInput--button':!libraryPhoto}"
                button-class="a-button a-button--fullwidth"
                :removable="true"
                remove-button-class="a-button a-button--fullwidth"
                @change="onChange"
                @remove="onRemove"
                :hide-change-button="true"
                :size="10"
                ref="pictureInput"
            />
            <a-button
                v-if="img != null"
                type="fullwidth"
                @click="savePhoto"
            >
                Zapisz
            </a-button>
        </div>
        <div v-show="img != null && libraryPhoto == false">
            <div class="o-photos__webcam">
                <figure class="figure">
                    <img :src="img" class="img-responsive" />
                </figure>
            </div>
            <p class="">Czy chcesz dodać to zdjęcie?</p>
            <br />
            <a-button
                type="fullwidth"
                @click="onStart"
            >
                Wykonaj jeszcze raz
            </a-button>
            <br /><br />
            <a-button
                type="fullwidth"
                @click="savePhoto"
            >
                Zapisz
            </a-button>
        </div>
        <br />
        <a-button
            type="fullwidth"
            class="a-button"
            @click="$router.go(-1)"
        >
            Powrót
        </a-button>
    </div>
</template>

<script>
import { WebCam } from 'vue-web-cam'
import vuePictureInput from 'vue-picture-input'
export default {
    metaInfo: {
        title: 'Dodaj zdjęcie'
    },
    components: {
        'vue-web-cam': WebCam,
        vuePictureInput
    },
    data() {
        return {
            img: null,
            camera: null,
            deviceId: null,
            devices: [],
            libraryPhoto: false
        }
    },
    computed: {
        device() {
            return this.devices.find(n => n.deviceId === this.deviceId)
        },
        token() {
            return this.$store.getters.token
        }
    },
    watch: {
        camera(id) {
            this.deviceId = id
        },
        devices() {
            // once we have a list select the first one
            let camera = {}
            if(this.devices.length === 1) {
                camera = this.devices[0]
            } else {
                const idx = this.devices.findIndex(device => {
                    return device.label.includes('back') || device.label.includes('yln')
                })
                // if there is no back camera
                if(idx === -1) {
                    // set to last one
                    camera = this.devices[this.devices.length - 1]
                } else {
                    camera = this.devices[idx]
                }
            }

            if (camera) {
                this.camera = camera.deviceId
                this.deviceId = camera.deviceId
            }
        }
    },
    methods: {
        onStart() {
            this.img = null
            this.$refs.webcam.start()
        },
        onCapture() {
            this.img = this.$refs.webcam.capture()
        },
        onError(error) {
            console.log('On Error Event', error)
        },
        onCameras(cameras) {
            this.devices = cameras
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId
            this.camera = deviceId
        },
        savePhoto() {
            this.$store.dispatch('addPhoto', { image: this.img })
            this.$router.push(this.$store.getters.photosRouterBack)
        },
        onChange (image) {
            if (image) {
                // rotate image so iOS images are facing correctly
                this.$refs.pictureInput.rotate = 0
                this.img = image
                this.libraryPhoto = true
            } else {
                console.log('FileReader API not supported: use the <form>')
            }
        },
        onRemove() {
            this.img = null
            this.libraryPhoto = false
        },
        loadFromGallery() {
            const loadFromGallery = document.querySelector('.picture-preview')
            loadFromGallery.click()
        }
    },
    mounted() {
        if(Object.keys(this.$store.getters.photosRouterBack).length === 0 || this.$store.getters.photosRouterBack === undefined) {
            this.$router.push({ name: 'dashboard' })
        }
    }
}
</script>
